export default {
    de: {
      "homepage.title": "SDK Simulator",
      "homepage.gemeinde": "Gemeinde",
      "homepage.haushalte": "Haushalte",
      "homepage.schätzung": "Schätzung der Abfallmengen Ihrer Residenz",
      "homepage.abfallname": "Abfallname",
      "homepage.leerungen": "Leerungen pro Jahr",
      "homepage.volumen": "Volumen (l) pro Leerung",
      "homepage.säcke": "Säcke (60 l) pro Leerung",
      "homepage.berechnen": "Berechnen",
      "homepage.abfallmenge": "Abfallmenge",
      "table.säcke": "Säcke 60 l",
      "000000": "Problemabfälle",
      "120100": "Karton, Papier",
      "150140": "Hohlglas",
      "190101": "Restabfall",
      "290001": "Bioabfall",
      "300198": "PMC-Verpackungen",
    },
    fr: {
        "homepage.title": "Simulateur SDK",
        "homepage.gemeinde": "Commune",
        "homepage.haushalte": "Ménages",
        "homepage.schätzung": "Estimation des quantités de déchets résidentiels",
        "homepage.abfallname": "Nom du déchet",
        "homepage.leerungen": "Vidanges par année",
        "homepage.volumen": "Volume (l) par vidange",
        "homepage.säcke": "Sacs (60 l) par vidange",
        "homepage.berechnen": "Calculer",
        "homepage.abfallmenge": "Quantités de déchets",
        "table.säcke": "sacs de 60 l",
        "000000": "Déchets problématiques",
        "120100": "Papier et carton",
        "150140": "Verre creux",
        "190101": "Déchets résiduels",
        "290001": "Déchets bio",
        "300198": "Emballages PMC",
    },
    en: {
      "homepage.title": "SDK Simulator",
      "homepage.gemeinde": "Municipality",
      "homepage.haushalte": "Households",
      "homepage.schätzung": "Estimated quantities of residential waste",
      "homepage.abfallname": "Name of the waste",
      "homepage.leerungen": "Emptying per year",
      "homepage.volumen": "Volume (l) per emptying",
      "homepage.säcke": "Bags (60 l) per emptying",
      "homepage.berechnen": "Calculate",
      "homepage.abfallmenge": "Waste quantities",
      "table.säcke": "bags of 60 l",
      "000000": "Problematic wastes",
      "120100": "Paper and cardboard",
      "150140": "Hollow glass",
      "190101": "Residual waste",
      "290001": "Bio-waste",
      "300198": "Packaging (Valorlux)",
    }
  };
